"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbNodeRegistry = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("./dbNodes"));
const createRegistryEntry = (node) => ({
    artifactType: node.artifactType,
    cloneArtifact: ({ artifact, errorPrefix, ...params }) => {
        (0, common_1.finleyAssert)(node.hasArtifactType(artifact), `${errorPrefix}: expected ${node.artifactType} node, got: ${artifact.type}`);
        // Clone runs only on the backend, so it validates the whole node, not
        // just its type, before copying the configuration into a new graph.
        const errors = [];
        (0, common_1.finleyAssert)(node.typeGuard(artifact, (e) => errors.push(...e)), `${errorPrefix}: invalid ${node.artifactType} node [id:${artifact.id}]: ${errors.join('; ')}`);
        return node.cloneFromTemplateArtifact({
            artifactToClone: artifact,
            ...params,
        });
    },
});
/**
 * Every dbNodes node type, keyed by its artifact type. The mapped type makes
 * this exhaustive and requires each key to match its module's `artifactType`.
 */
exports.dbNodeRegistry = {
    assignedLoanTape: createRegistryEntry(dbNodes.assignedLoanTape),
    assignedRepaymentTape: createRegistryEntry(dbNodes.assignedRepaymentTape),
    borrowingBaseReport: createRegistryEntry(dbNodes.borrowingBaseReport),
    busCertificate: createRegistryEntry(dbNodes.busCertificate),
    cashBalancesFeedContext: createRegistryEntry(dbNodes.cashBalancesFeedContext),
    cashResponseTape: createRegistryEntry(dbNodes.cashResponseTape),
    configTape: createRegistryEntry(dbNodes.configTape),
    dataLakeTape: createRegistryEntry(dbNodes.dataLakeTape),
    directInsertBorrowingBaseReport: createRegistryEntry(dbNodes.directInsertBorrowingBaseReport),
    directInsertFinancialCovenants: createRegistryEntry(dbNodes.directInsertFinancialCovenants),
    directInsertPortfolioCovenant: createRegistryEntry(dbNodes.directInsertPortfolioCovenant),
    directInsertPortfolioCovenants: createRegistryEntry(dbNodes.directInsertPortfolioCovenants),
    finStatement: createRegistryEntry(dbNodes.finStatement),
    forwardedTape: createRegistryEntry(dbNodes.forwardedTape),
    fundingApprovalReport: createRegistryEntry(dbNodes.fundingApprovalReport),
    fundingRequest: createRegistryEntry(dbNodes.fundingRequest),
    fundingVerificationReport: createRegistryEntry(dbNodes.fundingVerificationReport),
    generatedCashBalanceFeed: createRegistryEntry(dbNodes.generatedCashBalanceFeed),
    generatedCovenantLoanTape: createRegistryEntry(dbNodes.generatedCovenantLoanTape),
    generatedFinancialData: createRegistryEntry(dbNodes.generatedFinancialData),
    generatedLoanTape: createRegistryEntry(dbNodes.generatedLoanTape),
    generatedRepaymentTape: createRegistryEntry(dbNodes.generatedRepaymentTape),
    generatedSupplementalTape: createRegistryEntry(dbNodes.generatedSupplementalTape),
    intermediateTape: createRegistryEntry(dbNodes.intermediateTape),
    internalRepaymentTape: createRegistryEntry(dbNodes.internalRepaymentTape),
    limitedPartnersTape: createRegistryEntry(dbNodes.limitedPartnersTape),
    manualBankAccountReport: createRegistryEntry(dbNodes.manualBankAccountReport),
    masterLoanTape: createRegistryEntry(dbNodes.masterLoanTape),
    orgProvidedInput: createRegistryEntry(dbNodes.orgProvidedInput),
    orgProvidedInputs: createRegistryEntry(dbNodes.orgProvidedInputs),
    rawCashBalanceFeed: createRegistryEntry(dbNodes.rawCashBalanceFeed),
    rawLoanTape: createRegistryEntry(dbNodes.rawLoanTape),
    rawReceivableDocumentation: createRegistryEntry(dbNodes.rawReceivableDocumentation),
    rawRepaymentTape: createRegistryEntry(dbNodes.rawRepaymentTape),
    rawSupplementalTape: createRegistryEntry(dbNodes.rawSupplementalTape),
    rawZipTape: createRegistryEntry(dbNodes.rawZipTape),
    receivableDocumentationVerificationReport: createRegistryEntry(dbNodes.receivableDocumentationVerificationReport),
    receivableInvoice: createRegistryEntry(dbNodes.receivableInvoice),
    receivableResponseTape: createRegistryEntry(dbNodes.receivableResponseTape),
    receivableResponseTapePreview: createRegistryEntry(dbNodes.receivableResponseTapePreview),
    reconciledBusTape: createRegistryEntry(dbNodes.reconciledBusTape),
    uploadToDatalake: createRegistryEntry(dbNodes.uploadToDatalake),
    userInputNeeded: createRegistryEntry(dbNodes.userInputNeeded),
    valleyBankIngest: createRegistryEntry(dbNodes.valleyBankIngest),
    valleyBankSlsCommitment: createRegistryEntry(dbNodes.valleyBankSlsCommitment),
    valleyBankSlsIngest: createRegistryEntry(dbNodes.valleyBankSlsIngest),
    waitForDataLakeTable: createRegistryEntry(dbNodes.waitForDataLakeTable),
};
//# sourceMappingURL=registry.js.map